import { HorizontalScroll as FASTHorizontalScroll } from '@microsoft/fast-components';
import { html } from '@microsoft/fast-element';
import { foundationHorizontalScrollStyles as styles } from './horizontal-scroll.styles';
import { foundationHorizontalScrollTemplate as template } from './horizontal-scroll.template';
/**
 * @tagname %%prefix%%-horizontal-scroll
 */
export class HorizontalScroll extends FASTHorizontalScroll {
}
// explicitly declaring for extensibility
export const foundationHorizontalScrollShadowOptions = {
    delegatesFocus: true,
    mode: 'open',
};
export const defaultHorizontalScrollConfig = {
    nextFlipper: html `
    <foundation-flipper
      @click="${(x) => x.scrollToNext()}"
      aria-hidden="${(x) => x.flippersHiddenFromAT}"
    ></foundation-flipper>
  `,
    previousFlipper: html `
    <foundation-flipper
      @click="${(x) => x.scrollToPrevious()}"
      direction="previous"
      aria-hidden="${(x) => x.flippersHiddenFromAT}"
    ></foundation-flipper>
  `,
};
/**
 * The Foundation HorizontalScroll
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-horizontal-scroll\>
 */
export const foundationHorizontalScroll = HorizontalScroll.compose(Object.assign({ baseName: 'horizontal-scroll', template,
    styles, shadowOptions: foundationHorizontalScrollShadowOptions }, defaultHorizontalScrollConfig));
